import { all, takeEvery, put, select, call } from 'redux-saga/effects';
import actions from "./actions"
import {getDevice, getDevices} from "../../services/devices.service";
import {ReducerType} from "../reducer.type";
import { AxiosResponse } from 'axios';
import { WorkspaceType } from '../user/user.type';
import logError from "../../utils/logError";

const getWorkspace = (state: ReducerType) => state.user.activeWorkspace;

export function* GET_DEVICES(){
    try{
        const workspace: WorkspaceType = yield select(getWorkspace);
        const response: AxiosResponse<any> = yield call(
          getDevices,
          workspace.uuid
        );
        if(response.data){
            yield put({
                type: actions.SET_DEVICES,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/devices/sagas/GET_DEVICES", e); }
}

export function* GET_DEVICE(action: {payload: string, type:string}){
    try{
        const workspace: WorkspaceType = yield select(getWorkspace);
        const response: AxiosResponse<any> = yield call(
          getDevice,
          workspace.uuid,
          action.payload
        );
        if (response.data){
            yield put({
                type: actions.SET_DEVICE,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/devices/sagas/GET_DEVICE", e); }
}

export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_DEVICES, GET_DEVICES),
        takeEvery(actions.GET_DEVICE, GET_DEVICE)
    ])
}